import { schema } from 'normalizr';

export const addOnDefSchema = new schema.Entity('addOnDefs', {});
export const profitItemDefSchema = new schema.Entity('profitItemDefs', {});
export const discountDefSchema = new schema.Entity('discountDefs', {});
